import { Grid } from '@mui/material';
import { useEffect, useState } from 'react';
import { v4 as uuid } from 'uuid';
import BlockProps from '../../../models/BlockProps';
import Utils from '../../../utils/Utils';
import CloseButton from '../../Buttons/Close';
import EditableText from '../../Form/EditableText';
import BlockTitleData from './BlockTitleData';
import BlockComponentImage from '../../../models/BlockComponentValues/BlockComponentImage';
import BackGroundImageModal from '../../Modals/ImageModal/BackGroundImageModal';
import useGetBackground from '../../../hooks/UseGetBackground';
import useParallaxScript from '../../../hooks/useParallaxScript';
import config from '../../../config';

function BlockTitle({
  data, isEditing, isTemplate, editHandler, showImageModal, onCloseImageModal,
}: BlockProps) {
  const [props, setProps] = useState<BlockTitleData>(data.data as BlockTitleData);

  useEffect(() => {
    setProps(data.data as BlockTitleData);
  }, [data.data]);

  const handleUpdate = (text: string) => {
    props.title.value = text;
    editHandler(data.id, props);
  };

  const elementUuid = uuid();
  useParallaxScript(props.url?.settings?.parallaxBool, elementUuid, config.backgroundImage.parallaxEffect);

  return (
    <Grid
      id={elementUuid}
      container
      spacing={0}
      direction="column"
      alignItems="center"
      justifyContent="center"
      sx={{
        minHeight: 120,
        overflow: 'hidden',
        ...useGetBackground(
          props.url?.solidColor,
          props.url?.value,
          props.url?.settings?.scale,
          props.url?.settings?.scaleBool,
        ),
        backgroundPosition: 'center 0px',
      }}
    >
      {(isEditing && !isTemplate) && (
        <BackGroundImageModal
          backgroundImage={props.url}
          isShowModal={showImageModal}
          onCloseModal={onCloseImageModal}
          handleOnConfirm={(url: BlockComponentImage) => {
            const tempBg = { ...props, url: { ...url } };
            setProps(tempBg);
            editHandler(data.id, tempBg);
          }}
        />
      )}

      {props.title && (
        <Grid
          container
          direction="column"
          alignItems="center"
          justifyContent="center"
          className="block-content-wrapper"
          style={{
            margin: 'auto',
          }}
        >
          <Grid item sx={Utils.hoverBorder(isEditing)}>
            <CloseButton
              show={isEditing}
              updateHandler={() => {
                props.title = undefined;
                editHandler(data.id, props);
              }}
            />

            <EditableText
              text={props.title.value}
              textColor={props.title.settings?.textColor}
              isEditable={isEditing && !isTemplate}
              updateHandler={handleUpdate}
            />
          </Grid>
        </Grid>
      )}
    </Grid>
  );
}

export default BlockTitle;
